import { Action } from '@ngrx/store';
import { ActionOptionsArgs, BaseAction, SynchronisableAction } from '../../../core/store/actions/base-actions';
import { BaseObjectFilters } from '../../store/bootstrap';
import { JobType } from './job-type.model';

export const ENTITY = 'jobType';
export const REHYDRATE = '[JobType] Rehydrate';
export const REMOVE = '[JobType] Remove';
export const SUBMIT = '[JobType] Submit';
export const SET_FILTER = '[JobType] Set Filter';

export class SubmitAction extends SynchronisableAction {
    readonly entity = ENTITY;
    readonly type = SUBMIT;

    constructor(public payload: JobType, options?: ActionOptionsArgs) {
        super(payload, options);
    }

    getKey(): string {
        return `${this.entity}:entity:${this.payload.id}`;
    }
}

export class RehydrateAction implements Action {
    readonly type = REHYDRATE;

    constructor(public payload: Array<JobType>) {

    }
}

export class RemoveAction extends SynchronisableAction {
    readonly entity = ENTITY;
    readonly type = REMOVE;

    constructor(public payload: JobType, options?: ActionOptionsArgs) {
        super(payload, options);
    }

    getKey(): string {
        return `${this.entity}:entity:${this.payload.id}`;
    }
}

export class SetFilterAction extends BaseAction {
    readonly type = SET_FILTER;
    readonly entity = ENTITY;

    constructor(public payload: BaseObjectFilters, options?: ActionOptionsArgs) {
        super(payload, options);
    }
}

export type Actions
    = SubmitAction
    | RehydrateAction
    | RemoveAction
    | SetFilterAction;



// WEBPACK FOOTER //
// ./src/vas/business-objects/job-type/job-type.actions.ts